const json = {
    GE: {
        SKIP: 'გამოტოვება',
        SKIP_DESCRIPTION: 'გასაგრძელებლად დააჭირეთ გამოტოვებას'
    },
    EN: {
        SKIP: 'Skip video',
        SKIP_DESCRIPTION: 'Click skip to continue'
    }
}

export default json



// WEBPACK FOOTER //
// ./client/app/components/welcome/welcome.texts.js